export const TASK_TYPE_SURVEYS = "taskTypeSurveys";
export const TASK_TYPE_SURVEYS_COUNT = "taskTypeSurveysCount";
export const TASK_TYPE_SURVEYS_LOADING = "taskTypeSurveysLoading";
